import { Card, CardContent, Grid, Icon } from "@mui/material";
import React, { useEffect, useState } from "react";
import CoreH6 from "../../core/dataDisplay/CoreH6";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  ENTITY_STATUS,
} from "../../config/constants";
import { api_request } from "../../store/actions/commonAction";
import { useDispatch, useSelector } from "react-redux";
import {
  BILL_UPLOAD_ERROR,
  BILL_UPLOAD_SUCCESS,
  FETCH_INVOICES_ERROR,
  FETCH_INVOICES_SUCCESS,
} from "../../store/types/billTypes";
import CoreFileUploader from "../../core/inputs/CoreFileUploader";
import CoreSelect from "../../core/inputs/CoreSelect";
import {
  GET_STAT_ERROR,
  GET_STAT_SUCCESS,
} from "../../store/types/commonTypes";
import { setBillReducer } from "../../store/actions/billActions";
import Swal from "sweetalert2";
import {
  GET_BASIC_ERROR,
  GET_BASIC_SUCCESS,
} from "../../store/types/authTypes";
import { theme } from "../../config/theme";
import { useNavigate } from "react-router";
import moment from "moment";
import CoreTypographySubtitle2 from "../../core/dataDisplay/CoreTypographySubtitle2";
import { getImpFieldHelper } from "../../helper/utils";
import CoreH4 from "../../core/dataDisplay/CoreH4";

export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const uid = useSelector((state) => state?.auth?.uid);
  const tools = useSelector((state) => state?.common?.tools);
  const stat = useSelector((state) => state?.common?.stat);
  const billUploadSuccess = useSelector(
    (state) => state?.bill?.billUploadSuccess,
  );
  const billUploadError = useSelector((state) => state?.bill?.billUploadError);
  const billUploadMessage = useSelector(
    (state) => state?.bill?.billUploadMessage,
  );
  const billUploadData = useSelector((state) => state?.bill?.billUploadData);
  const docFields = useSelector((state) => state?.common?.docFields);
  const rolePermission = useSelector(
    (state) => state?.rolePermission?.rolePermission,
  );
  const roles = useSelector((state) => state?.common?.roles);
  const user = useSelector((state) => state?.auth?.user);
  const allDocs = useSelector((state) => state?.common?.allDocs);
  const [selTool, setSelTool] = useState(null);

  useEffect(() => {
    resetBillEdit();
    getDocstat();
    return () => {
      dispatch(
        setBillReducer({
          billUploadSuccess: false,
          billUploadData: null,
          jobBillsData: null,
        }),
      );
    };
  }, []);

  useEffect(() => {
    if (roles && user && roles?.length > 0) {
      const role = roles?.find((role) => role.id === user.roleId);
      setSelTool(role?.defaultTool);
    }
  }, [roles, user]);

  useEffect(() => {
    if (billUploadSuccess) {
      dispatch(
        api_request(
          API_METHOD_GET,
          "/business/individual/ProfileBasic",
          {},
          {
            _defaultFilter: encodeURIComponent(JSON.stringify({ userId: uid })),
          },
          null,
          GET_BASIC_SUCCESS,
          GET_BASIC_ERROR,
          true,
          false,
        ),
      );
      // alert(billUploadMessage);
      if (billUploadData.docId) {
        dispatch(
          setBillReducer({
            billUploadSuccess: false,
            docId: billUploadData.docId,
            docType: billUploadData.Type,
          }),
        );
        navigate("/" + selTool + "/single");
      } else {
        dispatch(
          setBillReducer({
            billUploadSuccess: false,
            billUploadData: null,
            jobBillsData: null,
          }),
        );
        Swal.fire({
          title: "Processing Started",
          text: "You will be notified via email once done",
          icon: "success",
          confirmButtonColor: theme.palette.primary.main,
        });
      }
    }
    if (billUploadError) {
      alert(billUploadMessage);
      dispatch(setBillReducer({ billUploadError: false }));
    }
  }, [billUploadSuccess, billUploadError]);

  const resetBillEdit = () => {
    dispatch(setBillReducer({ newDocHisId: null }));
  };

  const getDocstat = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/doc/stat",
        {},
        {},
        null,
        GET_STAT_SUCCESS,
        GET_STAT_ERROR,
        true,
        false,
      ),
    );
  };

  const onViewInvoice = (doc) => {
    dispatch(setBillReducer({ docId: doc.id, docType: doc.Type }));
    navigate("/" + doc.tool + "/single");
  };

  const handleToolChange = (e) => {
    setSelTool(e.target.value);
  };

  const handlePdfUpload = (file) => {
    let requestBody = {
      file: file,
      type: "vendor",
      tool: selTool,
    };
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/upload",
        requestBody,
        {},
        null,
        BILL_UPLOAD_SUCCESS,
        BILL_UPLOAD_ERROR,
        true,
        true,
      ),
    );
  };
  console.log(
    "HOME docFields ",
    docFields,
    "ASd",
    roles?.find((role) => role.id === user.roleId)?.defaultTool,
  );

  const permissions = rolePermission?.permissions?.map((per) => {
    return per.name;
  });
  return (
    <div
      style={{
        height: `calc(100vh - 68px)`,
        minHeight: `calc(100vh - 68px)`,
        width: "100%",
      }}
    >
      <div style={{ marginBottom: 16, height: "25%" }}>
        <Grid container spacing={2} style={{ height: "100%" }}>
          <Grid item xs={4} style={{ height: "100%" }}>
            <Card style={{ height: "100%" }}>
              <CardContent style={{ height: "100%" }}>
                <CoreH6>
                  Documents <br /> uploaded today
                </CoreH6>
                <CoreH4>{stat?.daily?.count || 0}</CoreH4>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={4} style={{ height: "100%" }}>
            <Card style={{ height: "100%" }}>
              <CardContent style={{ height: "100%" }}>
                <CoreH6>
                  Documents <br /> uploaded this month
                </CoreH6>
                <CoreH4>{stat?.monthly?.count || 0}</CoreH4>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={4} style={{ height: "100%" }}>
            <Card style={{ height: "100%" }}>
              <CardContent style={{ height: "100%" }}>
                <CoreH6>
                  Non-edited <br /> documents
                </CoreH6>
                <CoreH4>{stat?.nonEdited ? stat?.nonEdited : 0}</CoreH4>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
      <div style={{ height: "75%", maxWidth: "100%" }}>
        <Grid container spacing={2} style={{ height: "100%" }}>
          <Grid item xs={8} style={{ height: "100%" }}>
            <Card style={{ height: "100%", minHeight: "100%" }}>
              <CardContent style={{ height: "100%", minHeight: "100%" }}>
                <CoreDataTable
                  tableId="documentListLatest"
                  selectable={false}
                  elevation={false}
                  pagination={false}
                  noOfRows={7}
                  showToolbar={false}
                  rowActions={[{ icon: "visibility", onClick: onViewInvoice }]}
                  columns={[
                    {
                      view: (row) => {
                        return row._status === ENTITY_STATUS.processing ? (
                          <Icon title="processing" sx={{ fontSize: 16 }}>
                            autorenew
                          </Icon>
                        ) : row._status === ENTITY_STATUS.failed ? (
                          <Icon
                            title="failed"
                            sx={{
                              fontSize: 16,
                              color: theme.palette.error.main,
                            }}
                          >
                            cancel
                          </Icon>
                        ) : (
                          ""
                        );
                      },
                      name: "",
                      label: "",
                      width: "30px",
                    },
                    {
                      view: (row) => {
                        return allDocs?.find((doc) => doc.name === row?.type)
                          ?.label;
                      },
                      name: "documentType",
                      label: "Document Type",
                      width: "150px",
                    },
                    {
                      view: (row) => {
                        return row?.User?.Person?.firstName;
                      },
                      name: "uploadedby",
                      label: "Uploaded By",
                      width: "120px",
                    },
                    {
                      view: (row) => {
                        return moment(row?.createdAt).format("DD-MM-YYYY");
                      },
                      name: "date",
                      label: "Date",
                      width: "100px",
                    },
                    {
                      view: (row) => {
                        return getImpFieldHelper(row, docFields);
                      },
                      name: "Description",
                      label: "Details",
                    },
                    {
                      view: (row) => {
                        return getImpFieldHelper(row, docFields, 1);
                      },
                      name: "Description2",
                      label: ".",
                    },
                  ]}
                  userFilter={{ userId: uid }}
                  apiDetails={{
                    method: API_METHOD_GET,
                    path: "/business/all/DocList",
                    successType: FETCH_INVOICES_SUCCESS,
                    errorType: FETCH_INVOICES_ERROR,
                    authorized: true,
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={4} style={{ height: "100%" }}>
            <Card style={{ height: "100%", minHeight: "100%" }}>
              <CardContent style={{ height: "100%", minHeight: "100%" }}>
                <CoreH6>Upload new document</CoreH6>
                <Grid container>
                  <Grid item xs="2">
                    <CoreTypographySubtitle2 style={{ marginTop: 16 }}>
                      For
                    </CoreTypographySubtitle2>
                  </Grid>
                  <Grid item xs="10">
                    <CoreSelect
                      noLabel={true}
                      options={tools
                        ?.filter((tool) => permissions?.includes(tool.name))
                        ?.map((tool) => {
                          return { label: tool.label, value: tool.name };
                        })}
                      value={selTool}
                      handleChange={handleToolChange}
                    />
                  </Grid>
                </Grid>

                <CoreFileUploader
                  noText={true}
                  size={100}
                  handleChange={(file) => {
                    console.log("file", file);
                    handlePdfUpload(file);
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
